import type { FunctionComponent } from 'react';
import { Navigate } from 'react-router';

import type { PublicRouteProps } from './PublicRoute.props.ts';
import { useAuth } from '../../components/management/NewAuthProvider';

const PublicRoute: FunctionComponent<PublicRouteProps> = ({ element, redirectOnLoggedInTo = '/' }) => {
  const { user, hasAnyAppAccess } = useAuth();

  if (!user) {
    return element;
  }

  if (hasAnyAppAccess()) {
    return <Navigate to={redirectOnLoggedInTo} replace />;
  }

  return element;
};

export default PublicRoute;
